@import "../../../../shared/scss";

@mixin model-skeleton() {
  &.skeleton {
    // remove when fuel types feature is active
    & .media-container.skeleton-item {
      inline-size: p-px-to-rem(154px);
      block-size: p-px-to-rem(86px);
      border-radius: 4px;

      @include pds-media-query-min("s") {
        inline-size: p-px-to-rem(150px);
        block-size: p-px-to-rem(85px);
      }

      @include pds-media-query-min("xxl") {
        inline-size: p-px-to-rem(200px);
        block-size: p-px-to-rem(112px);
      }

      &::slotted(img) {
        visibility: hidden;
      }
    }

    & .model-container.skeleton-item {
      max-inline-size: $max-model-width;

      inline-size: 100%;
      border-radius: 4px;

      @include pds-media-query-min("s") {
        margin-block: 0;
        margin-inline: 0;
        margin-block-end: p-px-to-rem(8px);
      }

      @include pds-media-query-min("m") {
        block-size: p-px-to-rem(180px);
      }

      @include pds-media-query-min("l") {
        margin-block: 0;
        margin-inline: 0;
        margin-block-end: p-px-to-rem(16px);
      }

      &::slotted(phn-model-tile) {
        visibility: hidden;
      }
    }

    & .skeleton-item {
      inline-size: p-px-to-rem(100px);

      @include pds-media-query-min("s") {
        inline-size: p-px-to-rem(87px);
      }
    }
  }
}

@mixin default-skeleton() {
  &.skeleton {
    & .skeleton-item {
      pointer-events: none;
      user-select: none;
      background: $pds-theme-light-contrast-low;
      border-radius: 4px;
    }

    & .skeleton-item * {
      visibility: hidden;
    }

    & .skeleton-item:empty::after,
    & .skeleton-item *:empty::after {
      content: "\00a0";
    }
  }
}

@mixin default-menu-item() {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  phn-p-link-pure,
  phn-p-button-pure,
  .pure-link,
  phn-nd-menu-item {
    box-sizing: border-box;
    padding-block: 0;
    padding-inline: 11px;

    phn-p-text {
      overflow: clip;
      font-size: p-px-to-rem(20px);

      @include pds-media-query-min-max("s", "l") {
        font-size: p-px-to-rem(18px);
      }
    }

    &.has-icon {
      padding-inline-start: 0;
    }

    .icon-container {
      position: relative;
      margin-inline-end: p-px-to-rem(4px);

      inline-size: p-px-to-rem(24px);
      block-size: p-px-to-rem(24px);

      @include pds-media-query-min-max("s", "m") {
        block-size: p-px-to-rem(28px);
        inline-size: p-px-to-rem(28px);
      }

      @include pds-media-query-min-max("m", "xl") {
        inline-size: p-px-to-rem(24px);
        block-size: p-px-to-rem(24px);
      }

      @include pds-media-query-min("xl") {
        inline-size: p-px-to-rem(28px);
        block-size: p-px-to-rem(28px);
      }

      phn-p-icon {
        margin-inline-end: p-px-to-rem(4px);
        inline-size: p-px-to-rem(24px);

        @include pds-media-query-min-max("s", "m") {
          inline-size: p-px-to-rem(28px);
        }
      }
    }
  }
}

@mixin model-menu-item() {
  phn-p-link-pure,
  phn-p-button-pure,
  .pure-link,
  phn-nd-menu-item {
    phn-p-text {
      font-size: p-px-to-rem(20px);

      @include pds-media-query-min("s") {
        font-size: p-px-to-rem(16px);
      }

      @include pds-media-query-min("xxl") {
        font-size: p-px-to-rem(20px);
      }
    }
  }
}

@mixin dealer-details-menu-item() {
  phn-p-link-pure,
  phn-p-button-pure,
  .pure-link,
  phn-nd-menu-item {
    phn-p-text {
      font-size: p-px-to-rem(16px);
    }

    .icon-container {
      phn-p-icon {
        margin-inline-end: p-px-to-rem(4px);
        inline-size: p-px-to-rem(24px);
      }
    }
  }
}

@mixin level1-menu-item() {
  phn-p-link-pure,
  phn-p-button-pure,
  .pure-link,
  phn-nd-menu-item {
    phn-p-text {
      overflow: clip;
      font-size: p-px-to-rem(22px);

      @include pds-media-query-min("s") {
        font-size: p-px-to-rem(18px);
      }

      @include pds-media-query-min("m") {
        font-size: p-px-to-rem(20px);
      }

      @include pds-media-query-min("xxl") {
        font-size: p-px-to-rem(24px);
      }
    }
  }
}

:host {
  @include default-menu-item();
  @include default-skeleton();

  &.model-variant {
    @include model-menu-item();
    @include model-skeleton();
  }

  &.dealer-details-variant {
    @include dealer-details-menu-item();
  }

  &.level1-variant {
    @include level1-menu-item();
  }

  & .pure-link {
    text-decoration: none;
    color: inherit;
    border-radius: 4px;
    padding-block: 2px;
    margin-block-start: -4px;
    transition: background-color var(--p-transition-duration, 0.25s)
      cubic-bezier(0.25, 0.1, 0.25, 1);

    @media (hover: hover) {
      &:hover {
        backdrop-filter: blur(32px);
        background-color: $pds-theme-light-state-hover;
      }
    }

    &:focus-visible {
      @include design-system__focus();
    }
  }

  &.account {
    @media (min-height: p-px-to-rem(634px)) {
      position: absolute;
      padding-inline: p-px-to-rem(27px); // Same as single-drawer
    }

    inset-inline: 0;
    inset-block-end: calc(
      p-px-to-rem(18px) + $pds-spacing-static-medium + 2px + 24px
    ); // see phn-nd-drawer-header

    & phn-p-button-pure {
      padding-inline-start: 8px;
    }

    & .phn-flex-row {
      gap: $pds-spacing-static-small;

      & phn-p-icon {
        margin-block-end: 2px;
      }
    }
  }
}

div.text-limit {
  @include pds-media-query-min("base") {
    inline-size: 220px;
  }

  @include pds-media-query-min("xs") {
    inline-size: 100%;
  }
}

.model-container {
  display: flex;
  justify-content: center;
  inline-size: 100%;
}
